export const translations = {
  it: {
    nav: { services: "Servizi", equipment: "Attrezzature", certifications: "Certificazioni", why: "Perché noi", waterproofing: "Impermeabilizzazione", contact: "Contatti", quote: "Richiedi preventivo" },
    hero: {
      eyebrow: "Protezione superfici industriali · dal 2008",
      line1: "Trattiamo l'acciaio",
      line2: "che protegge",
      line3: "l'industria.",
      sub: "Sabbiatura, verniciatura protettiva e impermeabilizzazione poliurea per serbatoi, strutture e impianti. Cantieri in tutta Italia ed Europa.",
      ctaPrimary: "Richiedi un sopralluogo",
      ctaSecondary: "Scopri i servizi",
      scroll: "Scorri",
    },
    trust: { since: "Operativi dal", iso: "Sistema certificato", isoDesc: "ISO 9001 · 14001 · 45001", nace: "Ispettori", naceDesc: "NACE · FROSIO", coverage: "Cantieri", coverageDesc: "Italia · Europa" },
    services: {
      tag: "01 — Cosa facciamo",
      title: "Servizi di protezione",
      subtitle: "Un ciclo completo di trattamento e protezione delle superfici, dalla preparazione al rivestimento finale.",
    },
    equipment: {
      tag: "02 — Parco macchine",
      title: "Attrezzature principali",
      subtitle: "Un parco macchine di proprieta per operare autonomi in ogni cantiere, dalla grande opera al dettaglio.",
      note: "Immagini rappresentative. Le foto reali dei mezzi verranno inserite dopo la verifica delle licenze.",
    },
    manifesto: { chapters: ["Preparazione", "Protezione", "Impermeabilizzazione", "Manutenzione", "Sicurezza", "Ambiente"] },
    process: {
      tag: "Il nostro metodo",
      title: "Dalla prima ispezione al collaudo finale",
      subtitle: "Un processo controllato e documentato in ogni fase, per garantire qualità, sicurezza e durata nel tempo.",
      steps: [
        { t: "Sopralluogo & ispezione", d: "Analisi tecnica dello stato delle superfici e definizione del ciclo di trattamento." },
        { t: "Cantierizzazione", d: "Allestimento in sicurezza: ponteggi, contenimento e abbattimento polveri." },
        { t: "Trattamento & applicazione", d: "Sabbiatura, verniciatura o poliurea con parametri controllati." },
        { t: "Collaudo & consegna", d: "Verifiche, misurazioni e documentazione di qualità a fine lavori." },
      ],
    },
    certs: {
      tag: "03 — Garanzie",
      title: "Certificazioni & qualità",
      subtitle: "Un sistema di gestione integrato, certificato secondo gli standard internazionali IQNet e Quality Austria.",
      items: [
        { code: "ISO 9001:2015", label: "Qualità", num: "N. 21772/0" },
        { code: "ISO 14001:2015", label: "Ambiente", num: "N. 03812/0" },
        { code: "ISO 45001:2018", label: "Sicurezza sul lavoro", num: "N. 00139/0" },
      ],
      verify: "Certificazioni IQNet & Quality Austria — dati reali, validita da verificare.",
    },
    why: {
      tag: "04 — Perché sceglierci",
      title: "Valori che tengono in piedi ogni cantiere",
      subtitle: "Non solo esecuzione: metodo, responsabilità e attenzione alle persone.",
      locationsTitle: "Le nostre sedi",
      values: [
        { t: "Sicurezza", d: "Procedure e DPI su ogni fase operativa." },
        { t: "Qualità", d: "Controlli e collaudi documentati." },
        { t: "Ambiente", d: "Recupero abrasivi e abbattimento polveri." },
        { t: "Salute", d: "Tutela costante degli operatori." },
        { t: "Risorse Umane", d: "Squadre formate e certificate." },
        { t: "Innovazione", d: "Tecnologie di blasting evolute." },
        { t: "Compliance", d: "Piena conformita normativa." },
      ],
    },
    waterproofing: {
      tag: "05 — Waterproofing",
      title: "Impermeabilizzazione poliurea",
      subtitle: "Membrane continue ad altissima resistenza, applicate a spruzzo per una protezione senza giunzioni.",
      apps: ["Tetti e coperture", "Terrazze", "Piscine", "Vasche e bacini", "Aree industriali"],
      cta: "Parla con un tecnico",
    },
    contact: {
      tag: "06 — Contatti",
      title: "Richiedi un preventivo",
      subtitle: "Raccontaci il tuo progetto: ti ricontattiamo per un sopralluogo o un preventivo dedicato.",
      name: "Nome e cognome", email: "Email", phone: "Telefono", company: "Azienda",
      service: "Servizio di interesse", message: "Descrivi il tuo progetto",
      selectService: "Seleziona un servizio",
      submit: "Invia richiesta", sending: "Invio in corso...",
      success: "Richiesta inviata! Ti ricontatteremo al più presto.",
      error: "Si e verificato un errore. Riprova tra poco.",
    },
    footer: { tagline: "Protezione e trattamento delle superfici industriali dal 2008.", rights: "Tutti i diritti riservati.", quickLinks: "Navigazione", legal: "P.IVA / Dati societari da inserire.", contactTitle: "Contatti", locationsTitle: "Sedi" },
  },
  en: {
    nav: { services: "Services", equipment: "Equipment", certifications: "Certifications", why: "Why us", waterproofing: "Waterproofing", contact: "Contact", quote: "Request a quote" },
    hero: {
      eyebrow: "Industrial surface protection · since 2008",
      line1: "We treat the steel",
      line2: "that protects",
      line3: "the industry.",
      sub: "Sandblasting, protective coating and polyurea waterproofing for tanks, structures and plants. Projects across Italy and Europe.",
      ctaPrimary: "Request a survey",
      ctaSecondary: "Explore services",
      scroll: "Scroll",
    },
    trust: { since: "Operating since", iso: "Certified system", isoDesc: "ISO 9001 · 14001 · 45001", nace: "Inspectors", naceDesc: "NACE · FROSIO", coverage: "Projects", coverageDesc: "Italy · Europe" },
    services: {
      tag: "01 — What we do",
      title: "Protection services",
      subtitle: "A complete surface treatment and protection cycle, from preparation to the final coating.",
    },
    equipment: {
      tag: "02 — Machinery",
      title: "Core equipment",
      subtitle: "An owned fleet to operate independently on every site, from major works to fine detail.",
      note: "Representative images. Real photos of the machines will be added after license verification.",
    },
    manifesto: { chapters: ["Preparation", "Protection", "Waterproofing", "Maintenance", "Safety", "Environment"] },
    process: {
      tag: "Our method",
      title: "From the first inspection to final testing",
      subtitle: "A controlled, documented process at every stage, ensuring quality, safety and long-term durability.",
      steps: [
        { t: "Survey & inspection", d: "Technical analysis of the surface condition and definition of the treatment cycle." },
        { t: "Site setup", d: "Safe setup: scaffolding, containment and dust abatement." },
        { t: "Treatment & application", d: "Sandblasting, coating or polyurea with controlled parameters." },
        { t: "Testing & handover", d: "Checks, measurements and quality documentation on completion." },
      ],
    },
    certs: {
      tag: "03 — Guarantees",
      title: "Certifications & quality",
      subtitle: "An integrated management system, certified to international IQNet and Quality Austria standards.",
      items: [
        { code: "ISO 9001:2015", label: "Quality", num: "No. 21772/0" },
        { code: "ISO 14001:2015", label: "Environment", num: "No. 03812/0" },
        { code: "ISO 45001:2018", label: "Occupational Safety", num: "No. 00139/0" },
      ],
      verify: "IQNet & Quality Austria certifications — real data, validity to be verified.",
    },
    why: {
      tag: "04 — Why choose us",
      title: "Values that hold every site together",
      subtitle: "Not just execution: method, responsibility and care for people.",
      locationsTitle: "Our locations",
      values: [
        { t: "Safety", d: "Procedures and PPE at every operational stage." },
        { t: "Quality", d: "Documented checks and testing." },
        { t: "Environment", d: "Abrasive recovery and dust abatement." },
        { t: "Health", d: "Constant protection of operators." },
        { t: "Human Resources", d: "Trained and certified crews." },
        { t: "Innovation", d: "Advanced blasting technologies." },
        { t: "Compliance", d: "Full regulatory conformity." },
      ],
    },
    waterproofing: {
      tag: "05 — Waterproofing",
      title: "Polyurea waterproofing",
      subtitle: "Continuous, ultra-resistant membranes applied by spray for seamless protection.",
      apps: ["Roofs & coverings", "Terraces", "Swimming pools", "Tanks & basins", "Industrial areas"],
      cta: "Talk to a technician",
    },
    contact: {
      tag: "06 — Contact",
      title: "Request a quote",
      subtitle: "Tell us about your project: we will get back to you for a survey or a dedicated quote.",
      name: "Full name", email: "Email", phone: "Phone", company: "Company",
      service: "Service of interest", message: "Describe your project",
      selectService: "Select a service",
      submit: "Send request", sending: "Sending...",
      success: "Request sent! We will get back to you shortly.",
      error: "Something went wrong. Please try again shortly.",
    },
    footer: { tagline: "Industrial surface protection and treatment since 2008.", rights: "All rights reserved.", quickLinks: "Navigation", legal: "VAT / company details to be added.", contactTitle: "Contact", locationsTitle: "Locations" },
  },
};
